import {AvailabilityCheckStatus} from '../types';
import {isTerminalAvailabilityStatus} from './isTerminalAvailabilityStatus';

/**
 * Whether an availability-check result should upsert ByAdId / patch vehicle caches.
 * Rejects non-terminal statuses. Never overwrites `just_sold` or `unsupported_platform`
 * (list + detail can race with different batch cache keys; unsupported stays forever).
 */
export function shouldPersistAvailabilityCheckResult(
  existingStatus: AvailabilityCheckStatus | undefined,
  incomingStatus: AvailabilityCheckStatus
): boolean {
  if (!isTerminalAvailabilityStatus(incomingStatus)) {
    return false;
  }

  if (existingStatus === 'just_sold' || existingStatus === 'unsupported_platform') {
    return false;
  }

  return true;
}
